// extracted by mini-css-extract-plugin
module.exports = {"dragItem":"EditableTagGroup_dragItem__f6Efk"};